// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3fbZV","productName":"Table_productName__2Ys24"};